import axios from "axios";
import React from "react";
import { Statistic, Card } from "antd";

const PlaysByPlatform = ({ data }) => {
  if (!data) return <div></div>;

  return (
    <Card title="Plays by Platform" className="w-full">
      <div className="text-center p-8 text-gray-500">
        <p>Analytics chart feature temporarily disabled</p>
        <p className="text-sm">Chart.js removed for compatibility</p>
      </div>
    </Card>
  );
};

const Statistics = ({ data }) => {
  if (!data) return <div></div>;

  let totalPlays = 0;
  let totalRevenue = 0;

  data.forEach((album) => {
    album.analyticsBL.forEach((analytic) => {
      totalPlays += parseInt(analytic.sold);
      totalRevenue += parseFloat(analytic.grossRevenue);
    });
  });

  const getRvenue = () => {
    let revenue = totalRevenue * 81.26;
    revenue = (70 / 100) * revenue;
    revenue = revenue.toFixed(3);
    return revenue;
  };

  return (
    <div className="p-4 w-full flex items-center justify-evenly">
      <Card>
        <Statistic title="Albums Releases" value={data.length} />
      </Card>

      <Card>
        <Statistic title="Total Plays" value={totalPlays} />
      </Card>

      <Card>
        <Statistic title="Total Revenue" value={`₹ ${getRvenue()}`} />
      </Card>
    </div>
  );
};

export default function Analytics() {
  const [theData, setTheData] = React.useState();
  React.useEffect(() => {
    (async () => {
      const result = await axios.get("/analytics");
      console.log(result.data.data);
      setTheData(result.data.data);
    })();
  }, []);
  return (
    <div className="h-full w-full">
      <Statistics data={theData} />
      <PlaysByPlatform data={theData}> </PlaysByPlatform>
    </div>
  );
}
